import React from "react";
import PropTypes from "prop-types";
import TextField from '@material-ui/core/TextField';
import Typography from "@material-ui/core/Typography";
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/AddCircleOutline";
import RemoveIcon from "@material-ui/icons/RemoveCircleOutline";


const useStyles = makeStyles(theme => ({
  select:{
      fontSize: '0.75rem',
  },
  formControl: {
    minWidth: 120,
    maxWidth: 300,
    margin: '0px',
    marginTop: '16px',
    marginRight: '16px'
  },
  typography: {
    color: 'rgba(0, 0, 0, 0.54)',
    padding: 0,
    fontSize: '1rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: 'translate(0, 1.5px) scale(0.75)',
    transformOrigin: 'top left',
    letterSpacing: '0.00938em',
    transition: 'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
  }
}));

const SubcontactSuscription = ({
  type,
  onChange,
  value,
  error,
  children,
  disabled,
  title,
  suscription_data,
  suscription_types,
  removeItem,
  addNewItem,
  ...props
}) => {


  const handleChange = event => {
    onChange(event, 'suscription_data')
  }

  const classes = useStyles();

  const handleAddItem = event => {
    event.preventDefault();
    event.stopPropagation();
    addNewItem('suscription_data');
  }

  const handleRemoveItem = (event, idx) =>{
    event.preventDefault();
    event.stopPropagation();
    removeItem('suscription_data', idx)
  }

  return (
    <React.Fragment>
      <Typography variant="h6" className="mt-2">
        {title}
      </Typography>

      {suscription_data.map((val,idx)=>{
      	return (
      		<React.Fragment>
	      		<div className="row ml-1">
	      			{(val.id > 0)
	      				?
							<TextField
								id={"suscription_data."+idx+".suscription"}
								name={"suscription_data."+idx+".suscription"}
								label="Suscripción"
								type="text"
								disabled={true}
								onChange={handleChange}
								value={suscription_data[idx].suscription}
								margin="normal"
								className="mr-2 "
								InputLabelProps={{
								  shrink: true
								}}
								inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
							/>
	      				
	      				:
							<FormControl className={classes.formControl} inputProps={{shrink: true}}><Typography className={classes.typography}>Suscripción</Typography>
								<Select native name='suscription_type'
								    inputProps={{
								      name:"suscription_type."+idx,
								      className:"suscription_type."+idx
								    }}
								    style={{minWidth: 150, fontSize: '0.75rem'}}
								    onChange={handleChange}
								    disabled={disabled}
								    value={val.suscription_type}
								    input={<Input id="grouped-native-select" name={"payment_method"}/>}>
								    <option value="" label="Seleccione"/>
								    {suscription_types.map((suscription_type) => <option id={suscription_type.name} value={suscription_type.name}>{suscription_type.name}
								  </option>)}
								</Select>
							</FormControl>  

	      			}
				<div class="mt-4" style={{width:"min-content", display:"inline-flex"}}>   
					<IconButton size="small" className={classes.iconButton} onClick={(e)=> {handleRemoveItem(e, idx)}}
					disabled={(suscription_data.length ==1) ? true : false} >
					  <RemoveIcon className={classes.deleteIcon} />
					</IconButton>
					<IconButton size="small" className={classes.iconButton} onClick={(e)=> {handleAddItem(e)}}>
					      <AddIcon className={classes.deleteIcon}/>
					</IconButton>
				</div>

	      		</div>
			</React.Fragment>      

  		)
      	
      })}

	</React.Fragment>
	)
}

SubcontactSuscription.defaultProps = {
  type: "text",
  className: "",
}

SubcontactSuscription.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  className: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired
}

export default SubcontactSuscription;	